export default "__VITE_ASSET__2eef23bd__"